import React from 'react';
import LocationTemplate from './LocationTemplate';

const SpringHopePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Spring Hope"
      stateName="North Carolina"
      countyName="Nash"
      zipCodes={["27882"]}
      latitude={35.9449}
      longitude={-78.0106}
      population={1339}
      historicalFact="Established in 1889 as a railroad town, named for the natural springs in the area."
      nearbyTowns={[
        "Nashville, NC",
        "Rocky Mount, NC",
        "Bailey, NC",
        "Elm City, NC",
        "Wilson, NC",
        "Middlesex, NC",
        "Castalia, NC",
        "Red Oak, NC"
      ]}
    />
  );
};

export default SpringHopePage;